export const LOAD_ALL_TYPES_INTO_STORE = 'LOAD_ALL_TYPES_INTO_STORE';
export const SAVE_DRAFT_TO_STORE = 'SAVE_DRAFT_TO_STORE';
export const GET_FORM_IO_FORM_ID = '@@DRIVER_REPORT/GET_FORM_IO_FORM_ID';
